import log from 'salvo-lite/log'

class QuantityButtons {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // get buttons
        const inc = this._elem.querySelector('.quantity-selector__increase')
        const dec = this._elem.querySelector('.quantity-selector__decrease')
        const productId = this._elem.getAttribute('product-id')

        if (inc === null || dec === null) return

        // add event listeners
        inc.addEventListener('click', () => this._updateQuantity(1, productId))
        dec.addEventListener('click', () => this._updateQuantity(-1, productId))
    }

    _updateQuantity (change, Id) {
        const valueElem = this._elem.querySelector('.quantity-selector__value').textContent
        const currentQuantity = parseInt(valueElem, 10) || 0
        const newQuantity = currentQuantity + change

        if (newQuantity >= 0) {
            this._changeQuantity(newQuantity, Id)
            valueElem.textContent = newQuantity
        }
    }

    _changeQuantity (quantity, Id) {
        const refresh = () => setTimeout(() => location.reload())
        // eslint-disable-next-line
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { quantity, id: Id },
            dataType: 'json',
            success: refresh
        })
    }
}

export default QuantityButtons



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuantityButtons.js